module.exports = __webpack_public_path__ + "static/tpp-image08-c30deb453c2d656b4233ebdc8fefe09c.jpg";